import { render, staticRenderFns } from "./InputCard.vue?vue&type=template&id=37e4b04c&scoped=true&"
import script from "./InputCard.vue?vue&type=script&lang=js&"
export * from "./InputCard.vue?vue&type=script&lang=js&"
import style0 from "./InputCard.vue?vue&type=style&index=0&id=37e4b04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4b04c",
  null
  
)

export default component.exports